import { useCallback, useEffect, useRef, useState } from "react";
import scroll_down from "../../_assets/images/scroll_down.png";
import scroll_down3 from "../../_assets/images/scroll_down3.png";
import scroll_down4 from "../../_assets/images/scroll_down4.png";
import { MainContainer, Container } from "../ComponentCss";
import { WarCommonComponent } from "../CommonComponent";
import FooterComponent from "../FooterComponent";
import { useLocation } from "react-router-dom";

const WarComponent = ({ playState, setBgIsBlack, setSupportVisible, setSpyEle, warEleRef }) => {    
    const audioRef = useRef();
    const componentRef = useRef([]);
    const componentContRef = useRef();
    const [eleScrollTop, setEleScrollTop] = useState([]);
    const [eleScrollBottom, setEleScrollBottom] = useState();
    const [selectComponent, setSelectComponent] = useState(0);

    const location = useLocation();

    const play = () => { audioRef.current.play(); };
    const pause = () => { audioRef.current.pause(); };

    useEffect(() => {        
        if (location.search.indexOf('war') > -1) {
            setSpyEle('war');
            play();
        }
    }, [location, setSpyEle])

    useEffect(() => {
        if (playState === "war") {
            // 각 element의 top값을 귀하기 위함
            const eleTopArray = componentRef.current.map(ele => ele.getBoundingClientRect().top + window.pageYOffset);
            const eleTop = componentContRef.current.getBoundingClientRect().top + window.pageYOffset;
            const eleIndex = eleTopArray.indexOf(eleTop);
            setEleScrollTop(eleTopArray);            
            setEleScrollBottom(componentContRef.current.getBoundingClientRect().bottom + window.pageYOffset);
            setSelectComponent(eleIndex);
        } else {
            pause();
        }
    }, [playState]); 

    const scrollHandler = useCallback(() => {
        // 스크롤 위치의 element를 알아내기위함
        
        if (eleScrollTop.length > 0) {
            let scrollY = window.scrollY + 100;
            const eleArr = eleScrollTop.filter(ele => scrollY >= ele);
            const eleIdx = eleScrollTop.indexOf(eleArr[eleArr.length-1]);
            if (eleIdx > -1) setSelectComponent(eleIdx);
            if (scrollY > eleScrollTop[2] + window.innerHeight) {
                pause();
            }
            if (scrollY < eleScrollTop[0]) {
                setSpyEle('');
            } else if (scrollY < eleScrollBottom) {
                setSpyEle('war');
            } else if (scrollY > eleScrollBottom) {
                setSpyEle('');
            } else {
                setSpyEle('war');
            }
        }

    }, [eleScrollTop, eleScrollBottom, setSpyEle]);

    useEffect(() => {
        window.addEventListener("scroll", scrollHandler);
        return () => {
        window.removeEventListener("scroll", scrollHandler);
        };
    }, [scrollHandler]);
    
    // 현재 보여지는 component가 변할때마다 scroll이동
    useEffect(() => {
        const audioPart = [{'s': 0, 'e': 10}, {'s': 11, 'e': 21}, {'s': 22, 'e': 31}];
        if (selectComponent !== null && playState === "war") {
            if (selectComponent < 3) {
                audioRef.current.currentTime = audioPart[selectComponent]['s'];
                play();
    
                const scrollInto = setInterval(() => {         
                    let currentTime = parseInt(audioRef.current.currentTime);
                    if (audioPart[selectComponent]['e'] === currentTime) {
                        componentRef.current[selectComponent+1].scrollIntoView({behavior: "smooth"});
                    }
                }, 1000);        
                return () => clearInterval(scrollInto);
            } 
        }
    }, [playState, selectComponent]);

    return (
        <>
        <section id="war" ref={ warEleRef }>
        <MainContainer ref={ componentContRef } style={{ position: 'relative' }} spyEle={ playState }>
            <audio preload="auto" loop={ false } src={ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/war_EFX.b15dcba7eed2957dfb43.mp3" } ref={ audioRef } style={{ position: 'fixed', top: 110,  zIndex: '1000000'}} />
            <Container className="p-1-w" ref={ el => componentRef.current[0] = el }>
                <div className="comm">
                    당신은 하마르와<br className="mo" /> 같은 지하실에 있습니다.
                </div>
                <img src={ scroll_down } alt="scroll down 이미지" className="scroll_img" />
            </Container>
            <Container className="p-1-w" ref={ el => componentRef.current[1] = el }>
                <div className="comm">
                    밖에서 갑자기<br className="mo" /> 거친 총성이 들려옵니다.
                </div>
                <img src={ scroll_down } alt="scroll down 이미지" className="scroll_img" />
            </Container>
            <Container className="p-3" ref={ el => componentRef.current[2] = el }>
                <div className="comm">
                    무장 단체가 설치한<br/>
                    폭탄이 터지고<br/>
                    당신과 하마르는 <br className="pc"/>
                    지하실 잔해에<br className="mo" /> 매몰되고 말았습니다.
                </div>
                <div className="scroll-cont" style={{ alignSelf: "center" }}>
                    <p>
                        스크롤을 내려 하마르의 이야기 들어보기
                    </p>
                    <img src={ scroll_down4 } alt="scroll down 이미지" className="pc" />
                    <img src={ scroll_down3 } alt="scroll down 이미지" className="mo" />
                </div>
            </Container>
            <WarCommonComponent warRef={ componentRef.current[3] } warRef2={ eleScrollTop[2] } setBgIsBlack={ setBgIsBlack } playState={ playState } setSupportVisible={ setSupportVisible } />
            </MainContainer>
        </section>
        <FooterComponent status={playState} setSpyEle={ setSpyEle }/>
        </>
    );
}

export default WarComponent;